<div
  class="layout-container"
  (click)="onWrapperClick()"
  (keydown.enter)="onWrapperClick()"
  tabindex="0"
  [ngClass]="{
    'layout-menu-horizontal': horizontal,
    'layout-menu-active': menuActive,
    'layout-top-small': topbarSize === 'small',
    'layout-top-medium': topbarSize === 'medium',
    'layout-top-large': topbarSize === 'large'
  }"
  [class]="topbarColor + ' ' + menuColor">
  <div class="layout-content">
    <div class="p-col-12 p-lg-3 p-md-3">
      <img
        src="assets/images/logo.png"
        class="layout-logo"
        style="width: 30%; padding: 0px 0px 10px 0px"
        alt="Company Logo" />
    </div>
  </div>
  <div class="layout-top">
    <app-topbar></app-topbar>
  </div>

  <div class="layout-content">
    <div class="layout-breadcrumb">
      <ul>
        <li>
          <a routerLink=""><i class="material-icons">home</i></a>
        </li>
        <li><i class="material-icons">chevron_right</i></li>
        <li><xng-breadcrumb></xng-breadcrumb></li>
      </ul>
    </div>

    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
      <router-outlet></router-outlet>
    }
  </div>

  @if (menuActive) {
    <div class="layout-mask" [@mask-anim]="'visible'"></div>
  }
  @if (configDialogActive) {
    <div class="layout-config-mask" [@mask-anim]="'visible'"></div>
  }
</div>
